import * as React from "react"
import { MenuItem, useMenuState, Menu } from "@szhsin/react-menu"
import "@szhsin/react-menu/dist/index.css"

export default function CountryDropdownMenu({ data }) {
  const ref = React.useRef(null)
  const [menuProps, toggleMenu] = useMenuState({ transition: true })

  return (
    <Menu
      transition={false}
      submenuCloseDelay={0}
      submenuOpenDelay={0}
      initialMounted
      transitionTimeout={0}
      menuButton={
        <a
          role="button"
          ref={ref}
          onPointerEnter={() => toggleMenu(true)}
          onClick={() => {
            toggleMenu(true)
          }}
          className="link color-white"
        >
          Parkingi przy lotnisku ⬇
        </a>
      }
    >
      {data.map(({ label, websites }, idx) => (
        <CountryMenu key={label} label={label} websites={websites} />
      ))}
    </Menu>
  )
}

const CountryMenu = ({ label, websites }) => {
  const [isCountryOpen, setIsCountryOpen] = React.useState(label === "Polska")
  return (
    <>
      <div
        className="navCountryItem"
        onClick={e => {
          e.stopPropagation = true
          e.keepOpen = true
          setIsCountryOpen(!isCountryOpen)
        }}
      >
        <span>{label}</span>
        {isCountryOpen && <span>↓</span>}
        {!isCountryOpen && <span>←</span>}
      </div>

      {isCountryOpen &&
        websites
          .filter(website => !website.disabled)
          .map(
            ({ name, url, outlined }) =>
              name && (
                <a
                  title={`Link do listy parkingów na lotnisku ${name.replace(
                    "Parking",
                    "",
                  )}`}
                  key={url}
                  className={outlined ? "link-highlight" : ""}
                  target="_blank"
                  href={url}
                >
                  <MenuItem>{name.replace("Parking", "Parkingi")}</MenuItem>
                </a>
              ),
          )}
    </>
  )
}
